export default __webpack_public_path__ + "static/media/0998_DSC7566.8956bcce.jpg";